import React from 'react';
import styles from './SocialProof.module.css';

const avatars = [
  { src: '/assets/website/avatar-1.png', alt: 'Client 1' },
  { src: '/assets/website/avatar-2.png', alt: 'Client 2' },
  { src: '/assets/website/avatar-3.png', alt: 'Client 3' },
  { src: '/assets/website/avatar-4.png', alt: 'Client 4' },
];

const SocialProof = ({ text = '500+ active clients' }) => {
  return (
    <div className={styles.social}>
      <div className={styles.social__avatars}>
        {avatars.map((avatar) => (
          <div key={avatar.alt} className={styles.social__avatar}>
            <img src={avatar.src} alt={avatar.alt} width="41" height="41" />
          </div>
        ))}
      </div>
      <div className={styles.social__rating}>
        <img src="/assets/website/stars.svg" alt="5 stars rating" className={styles.social__stars} width="92" height="14" />
        <span className={styles.social__text}>{text}</span>
      </div>
    </div>
  );
};

export default SocialProof;
